module.exports = require("./ar-SY.d.ts");